import React from 'react';
import { ParagraphText, Box, StackLayout } from '@leagueplatform/genesis-core';
import { SectionHeader } from '@leagueplatform/genesis-core-alpha';
import { useIntl } from '@leagueplatform/locales';

interface CardDetails {
  key?: string;
  value?: string;
}

interface CardDetailsTableProps {
  cardDetails: CardDetails[];
  hasDependents: boolean;
}
export const CardDetailsTable = ({
  cardDetails,
  hasDependents,
}: CardDetailsTableProps) => {
  const { formatMessage, $tifelse } = useIntl();

  if (cardDetails.length === 0) {
    return (
      <Box as="section">
        <ParagraphText>
          {$tifelse(
            hasDependents,
            'POLICY_INFORMATION_UNAVAILABLE_DEPENDENTS',
            'POLICY_INFORMATION_UNAVAILABLE',
          )}
        </ParagraphText>
      </Box>
    );
  }
  const validCardDetails = cardDetails.filter((card) => !!card.value);
  return (
    <StackLayout as="table" spacing="$one" css={{ borderCollapse: 'separate' }}>
      <Box as="caption">
        <SectionHeader
          headingLevel="2"
          title={formatMessage({ id: 'FOR_PROVIDERS_AND_PHARMACISTS' })}
          css={{ textAlign: 'start' }}
        />
      </Box>
      <Box as="tbody">
        {validCardDetails.map((card) => (
          <Box as="tr" key={card.key}>
            <ParagraphText
              as="th"
              emphasis="subtle"
              scope="row"
              css={{
                paddingTop: '$half',
                paddingBottom: '$half',
                textAlign: 'start',
                minWidth: '150px',
                paddingInlineEnd: '$half',
              }}
            >
              {card.key}:
            </ParagraphText>
            <ParagraphText
              as="td"
              css={{
                fontWeight: 'bold',
                paddingTop: '$half',
                paddingBottom: '$half',
              }}
            >
              {card.value}
            </ParagraphText>
          </Box>
        ))}
      </Box>
    </StackLayout>
  );
};
